<template>
  <Section style="overflow: auto">
    <template #header>
      <strong style="color:black">Referrals</strong>
      <span class="pl-2 grey--text"><em>(red entries are refunded)</em></span>
    </template>

    <table class="referrals">
      <thead class="grey--text font-weight-bold text--darken-2">
      <tr>
        <td class="lmost">Date</td>
        <td>Service</td>
        <td>Customer</td>
      </tr>
      </thead>
      <tr 
        v-for="referral in pro.referrals"
        :key="referral.referral_id"
        :class="lineColor(referral)"
      >
        <td class="lmost">{{ $formatters.formatDate(new Date(referral.referral_date)) }}</td>
        <td>{{ referral.service }}</td>
        <td>{{ referral.customer.name }}</td>
      </tr>
    </table>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'

  export default {
    props: ['pro'],

    components: { Section },
    methods: {
      lineColor(referral) {
        return {
          'red--text': referral.system_status == 'refunded',
          'grey--text': ['unopened', 'missed', 'saturated', 'expired'].includes(referral.system_status),
          'blue--text': ['claimed', 'rewarded', 'disputed'].includes(referral.system_status),
          'text--darken-3': ['claimed', 'rewarded', 'disputed'].includes(referral.system_status),
        }
      }
    },
  }
</script>